import styled, { css } from "styled-components";
import Box from "./Box";
export const Li = styled.li.withConfig({
  displayName: "List__Li",
  componentId: "sc-1izraak-0"
})([""]);
export const Ul = styled(Box).attrs({
  as: "ul"
}).withConfig({
  displayName: "List__Ul",
  componentId: "sc-1izraak-1"
})(["padding-left:0;list-style:none;margin:0;", " ", " ", ""], props => props.fullWidth && css(["width:100%;", "{width:100%;}"], Li), props => props.spaced && css(["", ":not(:first-child){padding-top:5px;}"], Li), props => props.lined && css(["", ":first-child{padding-bottom:5px;}", ":not(:first-child){border-top:1px solid grey;}"], Li, Li));
export const Ol = styled(Ul).attrs({
  as: "ol"
}).withConfig({
  displayName: "List__Ol",
  componentId: "sc-1izraak-2"
})([""]);
export default Ul;